"use client";

import { cn } from "@/lib/utils";
import { Typography } from "../Typography/Typography.component";
import { TextOverlayPropsModel } from "./TextOverlay.model";

const TextOverlay = ({ text }: TextOverlayPropsModel) => {
  return (
    <div
      className={cn(
        "overlay m-xxs bg-core-black absolute bottom-0 z-12",
        "rounded-l-[0.625rem] rounded-tr-[0.625rem] rounded-br-[1.25rem]",
      )}
    >
      <Typography.BODY2 className="overlay__content px-sm pb-lg pt-sm text-core-white">
        {text}
      </Typography.BODY2>
    </div>
  );
};

export default TextOverlay;
